import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { UserCog, Save } from "lucide-react";

export default function VoiceView({ onSaved }) {
  const { user } = useAuth();
  const [voice, setVoice] = useState(user?.voice_profile || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/profile/voice", { voice_profile: voice });
      onSaved?.();
      toast.success("Voice profile saved — every listing will sound like you.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="bg-white border border-slate-200 rounded-lg p-6">
        <h2 className="font-semibold text-lg flex items-center gap-2"><UserCog className="h-5 w-5" /> Your agent voice</h2>
        <p className="text-sm text-slate-500 mt-1">Describe your writing style, signature phrases, and tone. We'll weave it into every listing description.</p>
        <Textarea data-testid="voice-input" value={voice} onChange={(e) => setVoice(e.target.value)} rows={6} className="mt-4"
          placeholder="e.g. Warm but confident. I love leading with the lifestyle, use vivid sensory detail, keep sentences punchy, and always close with 'Let's get you home.'" />
        <Button onClick={save} disabled={saving} data-testid="voice-save-btn" className="mt-4 h-11 bg-slate-900 hover:bg-slate-800 text-white font-semibold">
          {saving ? "Saving…" : <><Save className="h-4 w-4 mr-2" /> Save voice profile</>}
        </Button>
      </div>
    </div>
  );
}
